import CompareValue from './CompareValues';

export default [
    {
        name: 'compare',
        path: '/compare',
        component: CompareValue,
    }
]


// WEBPACK FOOTER //
// ./src/pages/compare/routes.js